/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type PipeTransform, Pipe } from '@angular/core';
import { type CapacityDisk, type DiskData } from 'app/feature/system/storage-pool/model';

import { DiskTypeM, DiskTypeNamePair, DiskTypeOpts } from '../constants/disk-type';
import { ToolService } from '../services';
/**
 * 获取硬盘域硬盘类型
 */
@Pipe({ name: 'diskType' })
export class DiskTypePipe implements PipeTransform {
    constructor(private toolService: ToolService) { }

    transform(value: string | number, originalRequired?: boolean): string {
        const label = this.toolService.getLabelFromEnumOptions(DiskTypeOpts, Number(value));
        return originalRequired ? label : label.replace(/-/g, ' ').replace(/_/g, ' ');
    }

    getdiskLabel(value: string | number): string {
        return this.toolService.getLabelFromEnumOptions(DiskTypeOpts, Number(value));
    }

    // 判断硬盘类型A,B是否是同类型的加密&非加密
    isSameDiskType(typeA: string, typeB: string): boolean {
        if (typeA === typeB) {
            return true;
        }
        if (DiskTypeNamePair.get(typeA) === typeB) {
            return true;
        }
        return false;
    }

    // 盘类型合并展示：SSD,SSD SED---> SSD + SSD SED
    mergeByPlus(diskData: DiskData, disk: CapacityDisk): string {
        const typeArray = diskData.showType.split('+');
        if (!typeArray.includes(disk.diskType)) {
            typeArray.push(disk.diskType);
            typeArray.sort((a, b) => a.length - b.length);
            return typeArray.join('+');
        }
        return diskData.showType;
    }
    /*
    做硬盘类型校验时，不区分加密盘&非加密盘
    */
    mergeById(diskTypes: Array<string>): any[] {
        const typeNames = [];
        for (const typeId of diskTypes) {
            const name = DiskTypeM.get(typeId);
            if (!typeNames.includes(name)) {
                typeNames.push(name);
            }
        }
        return typeNames;
    }

    /*
    过滤加密类型
    */
    filterEncryptType(diskData: DiskData, disk: CapacityDisk): string {
        if (diskData.diskType === disk.diskType) {
            return diskData.diskType;
        }
        const types = [diskData.diskType, disk.diskType];
        return Array.from(types).filter((item) => !item.includes('SED'))[0];
    }

}
